import { useQuery } from "@tanstack/react-query";

import useCurrentStateAndParamsWithFixedDomain from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCurrentStateAndParamsWithFixedDomain";
import TechnologiesService from "app/pages/sales-intelligence/modules/technology/services/company-analysis-technologies-filter/technologiesService";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import { fetchSiteTechnologies } from "app/pages/website-analysis/website-technologies/technologiesApi";

import { companyAnalysisQueryKeys } from "./queryKeyFactory";

const useTechnologiesQuery = (options?: { enabled?: boolean; isWebsiteAnalysis?: boolean }) => {
    const { enabled = true, isWebsiteAnalysis } = options || {};
    const {
        params: { key: domain },
    } = useCurrentStateAndParamsWithFixedDomain();
    const { removeDuplicateTechnologies, sortTechnologies } = TechnologiesService;

    return useQuery({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: companyAnalysisQueryKeys.technologies(domain, !!isWebsiteAnalysis),
        queryFn: async ({ signal }) => {
            const data = isWebsiteAnalysis
                ? await fetchSiteTechnologies([domain])
                : await salesApiService.companyAnalysis.fetchCompanyTechnologies(domain, {
                      cancellation: signal,
                  });
            const result = sortTechnologies(removeDuplicateTechnologies(data));
            return result;
        },
        enabled: enabled && Boolean(domain),
    });
};

export default useTechnologiesQuery;
